"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _preactCompat = require("preact-compat");

var _Modal = require("@insided/shared/uikit/Modal");

var _ScreenArrow = _interopRequireDefault(require("@insided/destination/icons/ScreenArrow"));

var _Calendar = _interopRequireDefault(require("@insided/destination/icons/Calendar"));

var _OpenBookIcon = _interopRequireDefault(require("@insided/destination/icons/OpenBookIcon"));

var _Results = require("../Results");

var _results = require("@insided/destination/modules/Search/utils/results");

var _components = require("@insided/destination/modules/Search/components");

var _ExternalLinkV = _interopRequireDefault(require("@insided/destination/icons/ExternalLinkV2"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./utils");

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SmartSummarySources = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(SmartSummarySources, _PureComponent);

  var _super = _createSuper(SmartSummarySources);

  function SmartSummarySources() {
    var _this;

    (0, _classCallCheck2.default)(this, SmartSummarySources);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showModal: false
    });
    return _this;
  }

  (0, _createClass2.default)(SmartSummarySources, [{
    key: "onClose",
    value: function onClose() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          sources = _this$props.sources,
          loading = _this$props.loading;
      var showModal = this.state.showModal;
      var element = sources.map(function (topic) {
        var _topic$content2;

        if (topic.topicInfo) {
          var _topic$content;

          var topicInfo = topic.topicInfo;
          return (0, _results.isCommunityResultEvent)(topicInfo) ? (0, _preact.h)(_Results.SearchResult, {
            key: topic.id,
            clickCallback: function clickCallback() {},
            hideCategoryMetadata: (0, _utils.shouldHideCategoryMetadata)(topicInfo),
            content: (_topic$content = topic.content) !== null && _topic$content !== void 0 ? _topic$content : '',
            icon: (0, _preact.h)(_components.SearchResultIcon, {
              contentType: topic.topicInfo.contentType,
              width: 20,
              height: 20
            }),
            title: topic.title,
            url: topic.url,
            postTitleIconClass: (0, _classnames.default)({
              'icon-question icon--auto-width': topic.topicInfo.contentType === 'question',
              'icon--thread-solved': topic.topicInfo.answer,
              'icon--question-circle': !topic.topicInfo.answer && topic.topicInfo.contentType === 'question'
            })
          }) : (0, _preact.h)(_Results.SearchResult, {
            key: topic.id,
            title: topic.title,
            url: topic.url || '',
            clickCallback: function clickCallback() {},
            content: topic.first_post || '',
            icon: (0, _preact.h)(_Calendar.default, {
              width: 20,
              height: 16
            })
          });
        }

        return (0, _preact.h)(_Results.SearchResult, {
          key: topic.id,
          title: topic.title,
          url: topic.url || '',
          icon: (0, _preact.h)(_ExternalLinkV.default, {
            width: 20,
            height: 20
          }),
          content: (_topic$content2 = topic.content) !== null && _topic$content2 !== void 0 ? _topic$content2 : '',
          clickCallback: function clickCallback() {},
          anchorRel: "noreferrer"
        });
      });
      return (0, _preact.h)("div", {
        className: "sources"
      }, (0, _preact.h)("div", {
        className: "source-heading"
      }, (0, _preact.h)(_ScreenArrow.default, null), (0, _preact.h)(_phrase.default, {
        p: "search.smart.summary.learnMore"
      })), loading ? // TODO: Add skeleton loader here
      '' : (0, _preact.h)("div", {
        className: "source-list"
      }, sources.slice(0, 3).map(function (source) {
        return (0, _preact.h)(Source, {
          key: source.id,
          source: source
        });
      }), sources.length > 3 && (0, _preact.h)("button", {
        className: "show-more-sources",
        onClick: function onClick() {
          _this2.setState({
            showModal: true
          });
        }
      }, (0, _preact.h)(_phrase.default, {
        p: "search.smart.summary.moreSources",
        count: {
          moreCount: sources.slice(3).length
        }
      }))), (0, _preact.h)(_Modal.Modal, {
        isOpen: showModal,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Sources (".concat(sources.length, ")"),
        onClose: function onClose() {
          return _this2.onClose();
        }
      }), (0, _preact.h)(_Modal.ModalBody, null, element)));
    }
  }]);
  return SmartSummarySources;
}(_preactCompat.PureComponent);

var Source = function Source(_ref) {
  var source = _ref.source;

  var parsedTitle = _htmlParser.default.stripHtml(source.title);

  return (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(source.url),
    className: "source",
    target: "_blank",
    rel: "noreferrer"
  }, (0, _preact.h)(SourceIcon, {
    source: source
  }), (0, _preact.h)("div", {
    className: "title"
  }, parsedTitle));
};

var SourceIcon = function SourceIcon(_ref2) {
  var source = _ref2.source;
  // console.log(' --------> source', source)
  var communitySource = source.topicInfo;

  if ((communitySource === null || communitySource === void 0 ? void 0 : communitySource.contentType) === 'event') {
    return (0, _preact.h)(_Calendar.default, {
      width: 24,
      height: 24
    });
  } else if (communitySource !== null && communitySource !== void 0 && communitySource.contentType) {
    var _communitySource$firs;

    return (0, _preact.h)(_UserAvatar.default, {
      user: (_communitySource$firs = communitySource.firstPost) === null || _communitySource$firs === void 0 ? void 0 : _communitySource$firs.author,
      style: {
        width: '24px',
        height: '24px'
      }
    });
  }

  return (0, _preact.h)(_OpenBookIcon.default, {
    width: 24,
    height: 24
  });
};

var _default = SmartSummarySources;
exports.default = _default;